document.addEventListener('click', e => {
    const el = e.target.closest('.obfuscated-link');
    if (!el) return;

    e.preventDefault();

    const parts = JSON.parse(el.dataset.obf);
    const value = parts
        .flatMap(p => p.split(','))
        .map(c => String.fromCharCode(c))
        .join('')
        .trim();

    let href = value;

    if (el.dataset.type === 'tel') {
        const cleaned = value.replace(/[^0-9+]/g, '');
        if (!/^tel:/i.test(value)) {
            href = 'tel:' + cleaned;
        }
    }
    else if (el.dataset.type === 'mail' && !/^mailto:/i.test(value)) {
        href = 'mailto:' + value;
    }

    el.href = href;
    window.location.assign(href);
});
